// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d58d3f45","667":"442ac56c"}[chunkId] + ".chunk.js";
};